import playerNamesRaw from '../utils/playernames_by_team.json';

const getPlayerNames = () => {
  const playerNames = {};
  const data = playerNamesRaw.dados;

  Object.values(data).forEach((grupo) => {
    if (!grupo || typeof grupo !== 'object') return;
    Object.values(grupo).forEach((time) => {
      if (!time || !time.sigla || !time.jogadores) return;
      playerNames[time.sigla] = Object.entries(time.jogadores).reduce(
        (acc, [key, value]) => {
          acc[key] = value.nome;
          return acc;
        },
        {}
      );
    });
  });

  return playerNames;
};

export const playerNames = getPlayerNames();
